import React, { useState, useEffect, JSX } from 'react';
import Styles from '../lineTable/LineTableV3Refined.module.scss';

const OrderButton = ({
  content,
  isMobileFlow,
  sbStaticConstants,
  address,
  isAvailable,
  showPrice,
  createCartCall,
  updatedContent
}: any): JSX.Element => {
  const [isDisabled, setDisabled] = useState<boolean>(false);

  useEffect(() => {
    if ((!isMobileFlow && !isAvailable) || showPrice?.base === '') {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [content, showPrice, isAvailable]);

  return (
    <div>
      {isMobileFlow ? (
        updatedContent?.swapButton ? (
          updatedContent?.ctaLinkLabel && (
            <a onClick={createCartCall} className={`${isDisabled && Styles.disabled}`}>
              {updatedContent?.ctaLinkLabel}
            </a>
          )
        ) : (
          <button
            className={`primarybutton ${isDisabled && Styles.disabled}`}
            onClick={createCartCall}
            disabled={isDisabled}
          >
            <span className={Styles.buttontext}>{sbStaticConstants?.addToCartBtnTxt}</span>
          </button>
        )
      ) : (
        <>
          {address && Object?.keys(address)?.length > 0 ? (
            <>
              <button
                className={`primarybutton ${isDisabled && Styles.disabled}`}
                onClick={createCartCall}
                disabled={isDisabled}
              >
                <span className={Styles.buttontext}>{sbStaticConstants?.addToCartBtnTxt}</span>
              </button>
            </>
          ) : (
            <button onClick={createCartCall} className='configurebutton'>
              <span>{sbStaticConstants?.check_availability}</span>
            </button>
          )}
        </>
      )}
    </div>
  );
};
export default OrderButton;
